
import type { PropType } from 'vue';

import {
  defineComponent,
  onMounted,
} from 'vue';

import type {
  Project,
  User,
} from '@/types';

export default defineComponent({
  props: {
    project: {
      type: Object as PropType<Project>,
      required: true,
    },
    user: {
      type: Object as PropType<User>,
      required: true,
    },
  },
  setup(props) {
    onMounted(() => {
      const script = document.createElement('script');

      script.async = true;

      script.src = `https://embed.tawk.to/${props.project.tawk_to_property_id}/${props.project.tawk_to_widget_id}`;

      script.setAttribute('crossorigin', '*');

      script.id = 'tawkto-script';

      document.body.appendChild(script);

      const setUserAttributes = (): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window.Tawk_API && typeof window.Tawk_API.setAttributes === 'function') {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.Tawk_API.setAttributes({
            projectName: props.project.name,
            userId: props.user.id,
            userEmail: props.user.email,
          });
        } else {
          setTimeout(setUserAttributes, 500);
        }
      };

      setUserAttributes();
    });
  },
});
